import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class AdditionsMultiSelectCtrl implements IController {

  additions: any;
  selectedIds: any;
  optionIds: any;
  options: any;
  disableIds: any;
  isRequired: boolean;
  ngPlaceholder: string;
  onChange: Function;

  private searchTerm: string;

  /* @ngInject */
  constructor(private IamRequests, private $mdSelect, private $log, private $q: IQService, private PricePlanService) {
  }

  $onInit() {
    if (this.selectedIds && this.selectedIds.length) {
      if (this.optionIds) {
        this._getAdditions(this.optionIds);
      } else if (!this.options) {
        this.options = [];
        this._getAdditions();
      }
    }
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      if (!this.options) {
        this._getAdditions(changes.selectedIds.currentValue);
      }
    }
  }

  /////////////////////////////////////////////////////

  isItemDisabled(addition) {
    const disableIds = this.disableIds || [];
    return _.includes(disableIds, addition.id);
  }

  onOpen() {
    if (!this.options) {
      return this._getAdditions(this.optionIds);
    } else {
      return this.$q.when();
    }
  }

  onSelect(additions) {
    this.searchTerm = undefined;
    this.onChange({additions: additions});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  doneHideSelect() {
    this.searchTerm = '';
    this.$mdSelect.hide();
  }

  resetHideSelect() {
    this.searchTerm = '';
    this.onChange({additions: []});
    this.$mdSelect.hide();
  }

  _getAdditions(ids?) {
    return this.PricePlanService.getSiteAdditions(ids)
      .then((additions) => {
        this.options = additions;
        this.additions = _.filter(additions, (a) => {
          return _.includes(this.selectedIds, a.id);
        })
      })
      .catch((error) => {
        this.$log.error('Failed to get service areas @branchesMultiSelect@onOpen', error);
      });
  }

}

angular
  .module('bringoz.admin.commons')
  .component('additionsMultiSelect', {
    bindings: {
      additions: '<?',
      selectedIds: '<?',
      optionIds: '<?',
      options: '<?',
      disableIds: '<?',
      isRequired: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./additions-multi-select.html').default,
    controller: AdditionsMultiSelectCtrl
  });
